enum AvailableExtensionsIcons {
  Ai = "Ai",
  Css = "Css",
  Doc = "Doc",
  Exe = "Exe",
  Iso = "Iso",
  Jpeg = "Jpeg",
  Mp4 = "Mp4",
  Pdf = "Pdf",
  Png = "Png",
  Ppt = "Ppt",
  Psd = "Psd",
  Rtf = "Rtf",
  Xls = "Xls",
}

export default AvailableExtensionsIcons;